import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import RouterContainer from './flux/services/RouterContainer';

import * as serviceWorker from './serviceWorker';
var app = new App();
RouterContainer.set(app);
ReactDOM.render(/*<App />*/ app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
